import HIHButton from '../base/HIHButton';
import { SoonEmptyData } from '@/shared/types/contentModule';
import TripleLines from '../base/TripleLines';
import CoffeeSticker from '../base/CoffeeSticker';
import { URL_PAGE_ALWAYS } from '@/shared/constants';
import layoutStyles from '@/styles/section-layouts.module.scss';
import styles from './EventsCalendarEmpty.module.scss';

// Fallback per ticket HIH-1122 (taken over verbatim) for when no editorial
// empty-state content exists: default notice + button to the Geht-immer page.
const FALLBACK_COPY =
  'Für diesen Tag haben wir bisher keine Event-Tipps – aber es gibt viel mehr zu entdecken!';
const FALLBACK_LINK_LABEL = 'Jetzt weiter stöbern';

export default function EventsCalendarEmpty({
  emptyTeaser,
}: {
  emptyTeaser: SoonEmptyData | null;
}) {
  // Editorial content only applies when both text and target are present;
  // otherwise the fallback as a whole (text + button to the Geht-immer page).
  const editorial =
    emptyTeaser?.copy && emptyTeaser.linkLabel && emptyTeaser.linkPath
      ? emptyTeaser
      : null;

  const copy = editorial?.copy ?? FALLBACK_COPY;
  const linkLabel = editorial?.linkLabel ?? FALLBACK_LINK_LABEL;
  const linkPath = editorial?.linkPath ?? URL_PAGE_ALWAYS;
  const isExternalLink = editorial?.isExternalLink ?? false;

  return (
    <div className={[styles.wrapper, layoutStyles.containerContent].join(' ')}>
      <div className={styles.blobMobile}>
        <svg
          width="239"
          height="229"
          viewBox="0 0 239 229"
          fill="none"
          aria-hidden="true"
          focusable="false"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M134.129 2.64958C168.533 3.69279 209.15 -3.55294 229.955 23.868C250.53 50.9874 229.625 87.2093 223.72 120.735C217.101 158.312 229.456 210.367 194.438 225.518C159.441 240.661 132.022 192.52 98.1088 175.083C66.3592 158.759 21.2707 162.069 7.21045 129.254C-8.51896 92.544 2.45323 46.0326 30.7289 17.8269C56.6771 -8.05706 97.4953 1.53874 134.129 2.64958Z"
            fill="#EDEDED"
          />
        </svg>
      </div>
      <div className={styles.blobDesktop}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="449"
          height="401"
          viewBox="0 0 449 401"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M188.684 35.2696C248.713 16.4672 314.506 -20.3684 366.849 14.5194C418.617 49.0235 404.213 124.086 414.095 185.51C425.171 254.356 477.678 336.84 426.288 383.973C374.927 431.078 298.753 364.375 229.755 354.578C165.157 345.405 89.287 378.123 45.3574 329.883C-3.78708 275.916 -12.6963 189.035 19.2347 123.4C48.5374 63.1671 124.763 55.2908 188.684 35.2696Z"
            fill="#EDEDED"
          />
        </svg>
      </div>
      <div className={styles.content}>
        <h2 className={styles.title}>
          <TripleLines variant="topLeft" isLargeSize>
            Hier
          </TripleLines>{' '}
          gibt's noch nichts zu <CoffeeSticker>kieken</CoffeeSticker>
        </h2>
        <p className={styles.copy}>{copy}</p>
        <HIHButton link={linkPath} title={linkLabel} blank={isExternalLink} />
      </div>
    </div>
  );
}
